<template>
  <div class="landing_2025">
    <body>
      <header id="header" :class="{ sticky: isSticky, 'show-menu': isMenuVisible }">
        <div class="wrapper">
          <div class="site-logo">
            <button class="menu-toggle mobile-view" id="menuToggle" @click="toggleMenu">
              <img src="@assets/imgs/landing_2025/icon-menu.png" />
            </button>
            <img src="@assets/imgs/landing_2025/logo.png" alt="Sphir" @click="scrollToTop"/>
          </div>
          <nav class="nav-items desktop-view">
            <a href="#cardsCollections" class="nav-item" @click.prevent="scrollTo('#cardsCollections')">Collections</a>
            <a href="#search" class="nav-item" @click.prevent="scrollTo('#search')">Search</a>
            <a href="#exchange" class="nav-item" @click.prevent="scrollTo('#exchange')">Exchange</a>
          </nav>
          <div class="nav-actions">
            <button v-if="showAuthBtn" class="btn btn-secondary" @click="showLogin"> Login </button>
            <button v-if="showAuthBtn" class="btn btn-primary" @click="showJoin"> Join </button>
          </div>
          <div class="mobile-menu">
            <nav class="nav-items">
              <a href="#cardsCollections" class="nav-item" @click.prevent="scrollTo('#cardsCollections')">Collections</a>
              <a href="#search" class="nav-item" @click.prevent="scrollTo('#search')">Search</a>
              <a href="#exchange" class="nav-item" @click.prevent="scrollTo('#exchange')">Exchange</a>
            </nav>
          </div>
        </div>
      </header>
      <main>
        <section id="hero">
          <div class="wrapper section-1-wrapper">
            <div class="content">
              <h1>Welcome to Sphir</h1>
              <p>
                The internet is a whirlwind - great content appears and disappears in an instant, often lost in the noise.<br><br>
                That’s why we built Sphir - a platform designed to capture and preserve valuable insights like real-life experiences, game-changing life hacks, high-quality resources, and evolving research.<br><br>
                Sphir ensures that the best content doesn’t just vanish but instead, is here when you need it.<br><br>
              </p>
              <button v-if="showAuthBtn" class="btn btn-primary" @click="showJoin">Join</button>
              <figure class="banner-image">
                <img class="media-column-01" src="@assets/imgs/landing_2025/banner.png" alt=""/>
              </figure>
            </div>
          </div>
        </section>
        <section id="cardsCollections" class="cards-section right-card">
          <div class="wrapper">
            <div class="row">
              <div class="col-md-3">
                <div class="content">
                  <figure class="icon">
                    <img src="@assets/imgs/landing_2025/icon-note.png">
                  </figure>
                  <h2>Cards & <br>Collections</h2>
                   <p>
                    Cards are more than just bookmarks - they’re dynamic snapshots of valuable content added to Sphir. 
                    Whether it’s articles, blog posts, videos, products, business pages, or even your own original insights.
                    Cards help preserve and organize content that matters.
                   </p>
                   <p>
                    Collections take it a step further. They’re thoughtfully curated groups of Cards, strategically assembled to guide others through a specific topic or life experience. 
                    Whether it’s a deep dive or a quick starting point, Collections help turn scattered knowledge into a structured, meaningful resource.
                   </p>
                  <button v-if="showAuthBtn" class="btn btn-primary" @click="showJoin">Join</button>
                </div>
                  
              </div>
              <div class="col-md-9">
                <div class="row" style="position: relative;">
                  <div class="purple-bg"></div>
                  <div class="col-md-6">
                    <div class="media">
                      <figure class="collection-image">
                        <img src="@assets/imgs/landing_2025/collection.png">
                      </figure>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="media">
                      <figure class="card-image1">
                        <img src="@assets/imgs/landing_2025/card-2.png">
                      </figure>
                      <figure class="card-image2">
                        <img src="@assets/imgs/landing_2025/card-1.png">
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="search" class="cards-section left-card">
            <div class="wrapper">
                <div class="row">
                    <div class="col-md-3 order-md-2">
                        <div class="content">
                            <figure class="icon">
                                <img src="@assets/imgs/landing_2025/icon-search.png">
                            </figure>
                            <h2>Smarter Search</h2>
                             <p>
                              Our proprietary search mechanism is called the Social Graph Trust Rank™. With it, what you see first in the list of results, is content 
                              your trusted connections think is important, not ads or other manipulated content. Your results are always unique and meaningful to you.
                             </p>
                            <button v-if="showAuthBtn" class="btn btn-primary" @click="showJoin">Join</button>
                        </div>
                    </div>
                    <div class="col-md-9 order-md-1">
                        <div class="row" style="position: relative;">
                            <div class="purple-bg purple-bg-reduced"></div>
                            <div class="col-md-12">
                                <div class="media">
                                    <figure class="search-image">
                                        <img src="@assets/imgs/landing_2025/search-section.png">
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="exchange" class="cards-section right-card">
            <div class="wrapper">
                <div class="row">
                    <div class="col-md-3">
                        <div class="content">
                            <figure class="icon">
                                <img src="@assets/imgs/landing_2025/icon-exchange.png">
                            </figure>
                            <h2>The Exchange</h2>
                            <p>
                              In Sphir, your feed is called the Exchange – it’s a space designed for pure, personalized discovery and education. 
                              Unlike noisy traditional feeds, you have full control over what you see by following and connecting with specific accounts and 
                              fine-tuning your selections at any time. 
                              Plus, you’ll never see push ads or clutter - just high-quality content that matters to you.
                            </p>
                            <button v-if="showAuthBtn" class="btn btn-primary" @click="showJoin">Join</button>
                        </div>
                        
                    </div>
                    <div class="col-md-9">
                        <div class="row" style="position: relative;">
                            <div class="purple-bg purple-bg-reduced"></div>
                            <div class="col-md-12">
                                <div class="media">
                                    <figure class="exchange-image">
                                        <img src="@assets/imgs/landing_2025/exchange-section.png">
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="cta">
            <div class="wrapper">
                <div class="content">
                    <h2 class="text-color-dark">Ready to get started?</h2>
                    <p class="text-color-dark">
                      Get started right away or check out a few other things before you join. <br>You'll find more information about Sphir below.
                    </p>
                    <button v-if="showAuthBtn" class="btn btn-primary" @click="showJoin">Join</button>
                    <div class="site-links">
                      <a class="site-link" @click="goToDiscover"> Discover </a>
                      <a class="site-link" @click="goToAboutUs"> About Us </a>
                      <a class="site-link" @click="goToTerms"> Terms of Use </a>
                      <a class="site-link" @click="goToPolicy"> Privacy Policy </a>
                    </div>
                </div>
            </div>
        </section>
      </main>
      <footer>
          <div class="footer-wrapper">
              <div class="footer-logo">
                  <img src="@assets/imgs/landing_2025/logo.png" alt="Sphir"/>
              </div>
              <div class="footer-credits">
                &copy; {{ currentYear }} SPHIR. All Rights Reserved.
              </div>
              <div class="footer-social-links">
                <a class="social-link" @click="goToFacebook"><img src="@assets/imgs/landing_2025/icon-facebook.png"/></a>
                <a class="social-link" @click="goToRumble"><img src="@assets/imgs/landing_2025/icon-rumble.png"/></a>
              </div>
          </div>
      </footer>
    </body>
  </div>
</template>
  
<script>
  const HeaderBar = () => import('@components/HeaderBar')
  
  export default {
    name: 'Landing',
      components: {
          HeaderBar
      },
      data() {
        return {
          isSticky: true,
          isMenuVisible: false,
          currentYear: new Date().getFullYear(),
          options: {
            licenseKey: 'C0AE99B5-BC4C4C99-93F3DFD8-3B10F537',
            anchors: ['Page__0', 'Page__1', 'Page__2', 'Page__3', 'Page__4'],
            menu:'#landingPageNav',
            scrollOverflow: false,
            scrollBar: false,
            controlArrows: true
          },
        }
      },
      methods: {
          scrollToTop() {
              window.scrollTo({
                  top: 0,
                  behavior: 'smooth',
              });
          },
          scrollTo(targetId) {
              const targetElement = document.querySelector(targetId);
              if (targetElement) {
                  window.scrollTo({
                      top: targetElement.offsetTop - 100,
                      behavior: 'smooth',
                  });
              }
          },
          toggleMenu() {
              const header = document.getElementById("header");
  
              if (this.isMenuVisible) {
                  const overlay = document.getElementById("menuOverlay");
                  if (overlay) {
                  overlay.remove();
                  }
              } else {
                  const overlay = document.createElement("div");
                  overlay.id = "menuOverlay";
                  overlay.addEventListener("click", () => {
                  this.isMenuVisible = false;
                  const existingOverlay = document.getElementById("menuOverlay");
                  if (existingOverlay) {
                      existingOverlay.remove();
                  }
                  });
                  document.body.appendChild(overlay);
              }
  
              this.isMenuVisible = !this.isMenuVisible;
          },
          showLogin() {
              this.$modal.show('auth-form');
              // this.setAutoScrolling(false);
          },
          showJoin() {
              this.$modal.show('signup-form')
              // this.setAutoScrolling(false);
          },
          goToDiscover() {
              window.location = '/discover'
          },
          goToAboutUs() {
              window.location = '/about_us'
          },
          goToTerms() {
              window.location = '/terms_of_use'
          },
          goToPolicy() {
              window.location = '/privacy_policy'
          },
          goToFacebook() {
              window.location = 'https://www.facebook.com/wisdomsphir/'
          },
          goToRumble() {
              window.location = 'https://rumble.com/user/Sphir'
          },
          setAutoScrolling(value) {
            this.$refs.fullpage.api.setAutoScrolling(value);
          },
      }
  }
</script>
  
<style lang="scss">
  @import url("https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap");

  $white: #ffffff;
  $accent: #5647A4;
  $text-dark: #2D2D2E;
  $text-light: #FFFFFF;
  $bg-fade: #F7F9FB;
  $secondary: #ECEAF6;
  $purple: #7869BF;
  $border-gray: #A3A3A3;
  $hero-purple: #2A014A;
  $text-gray: #717680;

  .landing_2025 {
    * {
      box-sizing: border-box;
    }

    // Mixins
    @mixin flex-center {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    @mixin button-reset {
      border: 0;
      outline: none;
      box-shadow: none;
      background: none;
      cursor: pointer;
    }

    @mixin section-padding {
      padding: {
        top: 90px;
        bottom: 96px;
      }
    }

    body {
      font-family: "DM Sans", sans-serif;
      margin: 0;
      background-color: $white;
      transition: background-color 0.3s ease-in-out;
      scroll-behavior: smooth;
    }

    button {
      font-family: "DM Sans", sans-serif;
    }

    /* Utility Classes */
    .wrapper {
      max-width: 1300px;
      width: 100%;
      margin: 0 auto;
      padding: 0 20px;
    }

    .mobile-view {
      display: none !important;
    }

    .cursor-pointer {
      cursor: pointer;
    }

    /* Text Classes */
    .text {
      &-primary { 
        color: $accent !important; 
      }
      
      &-color {
        &-dark {
          color: $text-dark !important;
          transition: color 0.3s ease-in-out;
        }
        
        &-light {
          color: $text-light !important;
          transition: color 0.3s ease-in-out;
        }
      }
    }

    /* Button Styles */
    .btn {
      display: inline-block;
      padding: 6px 15px;
      text-align: center;
      border-radius: 14px;
      font-weight: 700;
      font-size: 14px;
      line-height: 3rem;
      border: 0px;
      @include button-reset;

      &.btn-primary {
        background-color: $accent;
        color: $text-light;
      }

      &.btn-secondary {
        background-color: $secondary;
        color: $accent;
      }
    }

    /* Main Content */
    main {
      max-width: 2560px;
      width: 100%;
      overflow: hidden;
      margin: 0 auto;
      padding-top: 85px;
    }

    /* Header Styles */
    header {
      padding: 22px 0;
      background-color: $white;
      position: relative;
      z-index: 98;

      &.sticky {
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 99;
      } 

      .wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        max-width: 2120px;

        .site-logo {
          display: flex;
          align-items: center;

          img {
            max-width: 140px;
            width: 100%;
          }

          .menu-toggle {
            display: flex;
            align-items: center;
            justify-content: center;
            border: 0;
            outline: none;
            box-shadow: none;
            padding: 0;
            margin: 0 20px 0 0;
            background: none;
            cursor: pointer;

            img {
              width: 20px;
            }
          }
        }

        .nav-items.desktop-view {
          display: flex;
          align-items: center;
          gap: 40px;
          padding-left: 90px;

          .nav-item {
            text-decoration: none;
            color: $text-dark;
            font-size: 16px;
            font-weight: 600;
            display: inline-block;

            &.active {
              color: $accent;
            }
          }
        }

        .nav-actions {
          display: flex;
          align-items: center;
          gap: 20px;

          .search-btn {
            @include flex-center;
            @include button-reset;
            padding: 0;
            margin: 0;

            img {
              width: 24px;
            }
          }
        }

        .mobile-menu {
          display: none;
          position: absolute;
          top: 100%;
          left: 0;
          width: 100%;
          border-top: 2px solid $border-gray;
          background-color: $white;

          .nav-items {
            display: flex;
            flex-direction: column;
            gap: 0;
            border-bottom: 2px solid #A3A3A3;

            .nav-item {
              width: 100%;
              padding: 15px 25px;
              text-align: center;
              font-size: 16px;
              font-weight: 600;
              border-top: 2px solid #A3A3A3;
              color: $accent; 
            }
          }
        }
      }

      &.show-menu .wrapper .mobile-menu {
        display: block;
        z-index: 98;
      }
    }

    /* Hero Section */
    #hero {
      @include section-padding;
      position: relative;
      background: url('../../assets/imgs/landing_2025/bg.png') no-repeat center top;

      .wrapper .content {
        h1 {
          font-size: 48px;
          font-weight: 700;
          margin: 0 0 35px;
          color: $hero-purple;
        }

        p {
          font-size: 18px;
          font-weight: 400;
          margin: 0 0 40px;
          color: $text-gray;
          line-height: 28px;
        }
      }
    }

    .banner-image {
      margin-top: 45px;
    }

    .section-1-wrapper {
      max-width: 950px;
      text-align: center;
    }

    /* Icon Styles */
    .icon {
      background: rgba(151, 21, 252, 0.1);
      clip-path: inset(0 0 0 0 round 15px);
      border-radius: 5px;
      padding: 10px;
      display: inline-block;
    }

    /* Purple Background */
    .purple-bg {
      background-color: #7869BF;
      border-radius: 28px;
      width: 100%;
      position: absolute;
      height: 397px;
      z-index: 0;
      top: -170px;

      &:after {
        content: "";
        background: rgb(86,71,164);
        background: linear-gradient(328deg, rgba(86,71,164,.05) 0%, rgba(86,71,164,0.006127450980392135) 30%);
        border-radius: 28px;
        width: 100%;
        position: absolute;
        height: 397px;
        z-index: -1;
        bottom: -100%;
        right: -25px;
      }
    }

    /* Cards Section */
    .cards-section {
      padding: 100px 0;
      margin: 100px 0 150px;

      &#exchange {
        margin-bottom: 0px;
      }

      .search-image, .exchange-image {
        position: relative;
        left: 24px;
        top: -50px;
      }

      &.right-card {
        .col-md-9 {
          padding-left: 100px;
        }
        .collection-image {
          padding-left: 20px;
        }
      }

      &.left-card {
        .col-md-9 {
          padding-right: 100px;
        }
        .card-image1 {
          float: right;
        }
        .card-image2 {
          right: auto;
          left: 30px;
        }
        .purple-bg:after {
          content: '';
          background: linear-gradient(45deg, rgba(86,71,164,.05) 0%, rgba(86,71,164,0.006127450980392135) 30%);
          right: auto;
          left: -25px;
        }
      }

      .col-md-3 {
        z-index: 1;
      }

      .col-md-6 {
        position: relative;
      }

      h2 {
        font-size: 32px;
        line-height: 44px;
        color: $hero-purple;
        margin-bottom: 30px;
        font-weight: 700;
      }

      p {
        font-size: 16px;
        line-height: 24px;
        color: $text-gray;
        margin-bottom: 30px;
        font-weight: 400;
      }
    }

    .card-image1 {
      margin-top: -61px;
    }

    .card-image2 {
      position: absolute;
      right: 30px;
      top: 155px;
    }

    /* CTA Section */
    #cta {
      @include section-padding;
      position: relative;
      background: url('../../assets/imgs/landing_2025/bg.png') no-repeat center top;
      background-size: contain;

      .wrapper {
        max-width: 750px;

        .content {
          margin: 0 auto;
          max-width: 740px;
          width: 100%;
          text-align: center;

          h2 {
            font-size: 36px;
            font-weight: 600;
            margin: 0 0 30px;
          }

          p {
            font-size: 18px;
            line-height: 28px;
            color: $text-gray;
            font-weight: 400;
            margin: 0 0 40px;
          }

          .site-links {
            @include flex-center;
            flex-wrap: wrap;
            gap: 20px;
            margin: 40px 0;

            .site-link {
              @include flex-center;
              font-size: 16px;
              text-decoration: none;
              color: #535862;
              padding: 5px 0px;
              font-weight: 600;
            }
          }
        }
      }
    }

    /* Footer */
    footer {
      padding: 0 25px;

      .footer-wrapper {
        border-top: 1px solid #e7eef3;
        padding: 40px 0;
        max-width: 2120px;
        width: 100%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .footer-logo img {
          max-width: 140px;
          width: 100%;
        }

        .footer-credits {
          font-size: 14px;
          color: $text-dark;
          font-weight: 400;
        }

        .footer-social-links {
          display: flex;
          align-items: center;
          gap: 20px;

          .social-link {
            @include flex-center;

            img {
              height: 20px;
              width: auto;
            }
          }
        }
      }
    }

    /* Media Queries */
    @media (max-width: 1024px) {
      .desktop-view {
        display: none !important;
      }
      .mobile-view {
        display: block !important;
      }
      header .wrapper .site-logo .menu-toggle {
        @include flex-center;
        @include button-reset;
        margin: 0 20px 0 0;
        
        img { width: 20px; }
      }

      #hero {
        .background {
          overflow: hidden;
          
          img {
            width: 1100px;
            object-fit: cover;
            height: 520px;
          }
        }

        .wrapper .content {
          padding: 0;
          
          h1 { font-size: 34px; }
          p { font-size: 16px; }
        }
      }
    }

    @media (max-width: 767px) {
      .cards-section {
        margin: 0;
        padding: 30px 0px;

        &.right-card, &.left-card {
          .col-md-9 {
            padding: 50px 12px;
          }
          .collection-image {
            padding-left: 0px;
          }
        }

        p { text-align: center; }

        .btn {
          margin: 0 auto;
          display: block;
        }
      }

      .card-image1, .card-image2 {
        margin-top: 0px;
        position: inherit;

        img { width: 100%; }
      } 
    }

    @media (max-width: 600px) {
      header .wrapper .nav-actions {
        gap: 5px;
      }

      #cta .wrapper .content .site-links {
        flex-direction: column;
      }

      footer .footer-wrapper {
        padding: 30px 0;
        flex-direction: column-reverse;
        gap: 20px;
      }
    }

    @media (max-width: 500px) {
      header {
        nav {
          padding-right: 0;
        }
        .wrapper {
          .site-logo {
            img {
              max-width: 95px;
            }
          .menu-toggle img {
              width: 16px;
            }
          }
          .btn {
            font-size: 12px;
          }
          // .nav-actions .btn {
          //   &.btn-primary,
          //   &.btn-secondary {
          //     font-size: 8px;
          //   }
          // }
        }
      }

      #hero {
        .banner-image {
          img {
            width: 390px;
          }
        }
      }

      .cards-section {
        .purple-bg-reduced {
          height: 500px !important;
          
          &::after {
            height: 500px !important;
          }
        }

        .search-image, .exchange-image {
          left: 10px;
          top: -10px;

          img {
            width: 360px;
          }
        }
        .col-md-9 {
          .row {
            position: relative;
          }
        }
        .content p {
          color: $text-light;
          font-weight: 600;
        }
        &.left-card {
          .card-image1 {
            float: none;
          }
        }
        
        &#cardsCollections {
          .purple-bg {
            top: -490px;
            height: 1800px;

            &::after {
              top: -490px;
              height: 1800px;
            }
          }
        }
        
        &#search {
          .purple-bg {
            top: -280px;
            height: 1500px;

            &::after {
              top: -280px;
              height: 1500px;
            }
          }
        }

        &#exchange {
          .purple-bg {
            top: -325px;
            height: 1500px;

            &::after {
              top: -325px;
              height: 1500px;
            }
          }
        }
        // .collection-image, .card-image1, .card-image2 {
        //   width: 350px;
        //   margin: 0 auto;
        //   padding: 20px 0;
        // }
      }
    }
  }

</style>
